import { useQuery } from "@tanstack/react-query";
import { useStoreId } from "../../../core/auth/useLoggedInUser";
import { fetchDivisionsCountByRound } from "../ShoppingToolsAPI";
import { INTERVAL } from "../../../constants/clientTime";
import { getStartOfDay } from "../helper";

export const useFetchDivisionsCountByRound = (
  division: string,
  roundName: string
) => {
  const storeId = useStoreId();
  const startOfDay = getStartOfDay();
  return useQuery<number>({
    queryKey: [
      "shopping-tools-divisions-count-by-round",
      storeId,
      division,
      roundName,
    ],
    queryFn: () => {
      return (
        fetchDivisionsCountByRound(storeId, division, roundName, startOfDay) ??
        0
      );
    },
    staleTime: INTERVAL.MINUTE * 1,
  });
};
